module.exports = __webpack_public_path__ + "static/media/clip.85813d6e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/clip.svg
// module id = 325
// module chunks = 0